<template>
	<section class="no_banner_page">
		<div class="mobile-banner" :style="bgCss"></div>
		<div class="container">
			<div class="contact_main">
				<p class="breadcrumbs">
					<router-link to="/" class="hp">דף הבית</router-link>
					<span class="spacer">/</span>
					<span class="current">לקוחות עיסקיים</span>
				</p>
				<h1 class="cat_title">{{ pageData.acf.title }}</h1>
				<h2 class="subtitle" v-html="pageData.acf.subtitle"></h2>
				<br />
				<div class="serv_box clearfix">
					<div class="right serv_wrap clearfix">
						<div class="right serv_item">
							<a
								:href="
									'tel:' +
									[
										globalOptions.main_phone
											? globalOptions.main_phone
											: '',
									]
								"
							>
								<span class="serv_icon ease">
									<PHONE />
								</span>
								<span class="serv_tx">{{
									globalOptions.main_phone
										? globalOptions.main_phone
										: ""
								}}</span>
							</a>
						</div>
						<div
							class="right serv_item hasTooltip"
							title="יש להוסיף את המספר לרשימת אנשי הקשר (אפשר לקרוא לנו 'כרמלה') ואז לשלוח לנו הודעה
"
						>
							<a
								:href="
									'https://api.whatsapp.com/send?phone=972' +
									globalOptions.whatsapp_phone.replace(
										/\D/g,
										''
									)
								"
							>
								<span class="serv_icon ease">
									<WHATSAPP />
								</span>
								<span class="serv_tx">{{
									globalOptions.whatsapp_phone
								}}</span>
							</a>
						</div>
						<div class="right serv_item">
							<a :href="'mailto:' + globalOptions.main_email">
								<span class="serv_icon ease">
									<MAIL />
								</span>
								<span class="serv_tx">{{
									globalOptions.main_email
								}}</span>
							</a>
						</div>
					</div>
				</div>

				<hr />

				<h2 class="subtitle" id="scroll-to-after-submit">
					{{ pageData.acf.form_title }}
				</h2>
				<br />

				<div
					v-html="pageData.form_html"
					v-if="!formSent"
					class="contact_form"
				></div>

				<div class="sent" v-if="formSent">
					<div class="img">
						<OK />
					</div>
					<p class="bold">ההודעה נשלחה!</p>
					<p class="">ניצור אתך קשר בהקדם</p>
				</div>
			</div>
		</div>
		<div class="contact_side" :style="bgCss">
			<div class="testimonials" :style="arrowsCss">
				<h2 class="testimonials-title">
					{{ pageData.acf.testimonials_title }}
				</h2>

				<Slick
					ref="slider"
					:options="slickOptions"
					v-if="pageData.acf.testimonials"
				>
					<div
						v-for="(item, i) in pageData.acf.testimonials"
						:key="i"
						class="testimonial-item-container"
					>
						<div class="testimonial-item">
							<h4 class="name">{{ item.title }}</h4>
							<div class="text" v-html="item.text"></div>
						</div>
					</div>
				</Slick>
			</div>
		</div>
	</section>
</template>

<script>
	import PHONE from "../assets/img/phone.svg";
	import WHATSAPP from "../assets/img/whatsapp.svg";
	import OK from "../assets/img/ok.svg";
	import MAIL from "../assets/img/mail.svg";
	import Slick from "vue-slick";

	export default {
		name: "B2bLeadForm",
		data() {
			return {
				wpData: window.wpData,
				pageData: window.wpData.pageData,
				globalOptions: window.wpData.globalOptions,
				formSent: false,
				slickOptions: {
					slidesToShow: 1,
					rtl: true,
					dots: true,
					// nextArrow: true,
					// prevArrow: true,
					adaptiveHeight: true,
					infinite: true,
					centerMode: false,
					slidesToScroll: 1,
					autoplay: false,
				},
			};
		},
		watch: {},
		methods: {},
		computed: {
			bgCss() {
				return (
					"background: #efede9 url('" +
					this.pageData.acf.bg_image.url +
					"') no-repeat center top"
				);
			},
			arrowsCss() {
				return {
					"--next-arrow":
						"url('" +
						this.wpData.assets_url +
						"/arrow_l.svg" +
						"')",
					"--prev-arrow":
						"url('" +
						this.wpData.assets_url +
						"/arrow_r.svg" +
						"')",
				};
			},
		},
		mounted() {
			console.log("Some debug message");
			// Sent
			document.addEventListener("wpcf7mailsent", (e) => {
				this.formSent = true;
				setTimeout(() => {
					document
						.querySelector("#scroll-to-after-submit")
						.scrollIntoViewIfNeeded();
				}, 500);
			});
		},
		components: {
			PHONE,
			WHATSAPP,
			OK,
			MAIL,
			Slick,
		},
	};
</script>

<style lang="sass" scoped>
	@import '../assets/sass/abstracts.sass'

	.mobile-banner
		display: none

	.breadcrumbs
		*
			display: inline-block
			color: $dark
		.spacer
			padding: 0 0.25rem
		.current
			font-weight: bold
		.hp:hover, .hp:focus
			color: $main
			text-decoration: underline

	.subtitle
		font-size: 20px

	.serv_box
		width: 32.01rem
		.serv_wrap
			width: 100%

	.contact_main
		width: 50%

	.contact_side
		width: 50%
		background-size: contain !important

		.testimonials
			margin: 29vw auto 0 auto
			text-align: center
			max-width: 30rem
			.testimonials-title
				font-size: 24px
				font-weight: bold
				margin-bottom: 1rem
			.testimonial-item-container
				padding: 0 1rem
			.testimonial-item
				padding: 2rem 1rem
				background-color: $white
				border-radius: 0.25rem

				&:before
					display: none
				.name
					font-weight: bold
					margin-bottom: 0.5rem
	.sent
		padding: 4rem
		background: $light_main
		border: 1px solid darken($grey, 15%)
		color: $dark
		display: flex
		flex-direction: column
		justify-content: center
		align-items: center
		max-width: 470px
		.bold
			font-weight: bold
		.img
			padding: 1rem
			height: 4rem
			width: 4rem
			border-radius: 100%
			border: 1px solid $dark
			display: flex
			justify-content: center
			align-items: center
			background-color: $white
			margin-bottom: 1rem
			svg
				width: 2rem
				height: 2rem

	@media screen and (max-width:800px)
		section
			background: $grey
		.contact_main
			width: 100%
			margin-left: 0
			margin-top: 1.5rem
		.serv_box
			width: 100%
		.serv_wrap .serv_tx
			display: block
			font-size: 0.65rem

		.no_banner_page
			padding-top: 0
		.mobile-banner
			display: block
			height: 55vw
			background-size: contain !important

		.contact_side
			display: block
			background: none !important
			width: 80%
			position: relative
			margin: 0 auto

			.testimonials
				margin-top: 0
</style>

<style lang="sass">
	.testimonials
		.slick-dots
			margin-top: 1rem
			bottom: auto
		.slick-next
			background-image: var(--next-arrow)
			background-size: contain
			background-repeat: no-repeat
			transform: translateX(-0.75rem)
			&:before
				opacity: 0
		.slick-prev
			background-image: var(--prev-arrow)
			background-size: contain
			background-repeat: no-repeat
			transform: translateX(1rem)
			&:before
				opacity: 0

		@media screen and (max-width:800px)
			.slick-next
				transform: translateX(0.5rem)
			.slick-prev
				transform: translateX(0)
</style>
